export default "__VITE_ASSET__mbdDZgyP__"